import { FC } from 'react';
import { Box } from '@mui/material';
import { FormikProps } from 'formik';

import styles from '../CreateIdeaStopModal/CreateIdeaStopModal.module.scss';
import { CreateIdeaStopFormData } from '../../../../../types/ideaStop.types';
import { useFormFieldRenderer } from '../CreateIdeaStopModal/hooks/useFormFieldRenderer';
import { isIdeaStopFieldMandatory } from '../../../../../types/ideaStop.config';
import CustomInput from '../../../../../common/CustomInput';

interface MandatoryFieldsProps {
  formik: FormikProps<CreateIdeaStopFormData>;
}

const MandatoryFields: FC<MandatoryFieldsProps> = ({ formik }) => {
  const { values, handleChange } = formik;
  const ideaStopType = values.ideaStopType;

  const { isFieldVisible, getError, renderFieldInput } = useFormFieldRenderer(formik, ideaStopType);

  return (
    <Box className={styles.formSection}>
      <CustomInput
        inputName="description"
        inputLabel="Description"
        value={values.description || ''}
        onChange={handleChange}
        error={getError('description')}
        placeholder="Describe this stop..."
      />

      {isFieldVisible('name') && (
        <CustomInput
          inputName="name"
          inputLabel="Name"
          value={values.name || ''}
          onChange={handleChange}
          error={getError('name')}
          placeholder="Enter name..."
        />
      )}

      {isFieldVisible('place') && isIdeaStopFieldMandatory('place', ideaStopType) && (
        <CustomInput
          inputName="place"
          inputLabel="Place"
          value={values.place || ''}
          onChange={handleChange}
          error={getError('place')}
          placeholder="Enter place name..."
        />
      )}

      {isFieldVisible('flightFrom') && isIdeaStopFieldMandatory('flightFrom', ideaStopType) && (
        <Box className={styles.locationFields}>
          {renderFieldInput('flightFrom', 'Flight From')}
          {renderFieldInput('flightTo', 'Flight To')}
        </Box>
      )}

      {isFieldVisible('countryFrom') && (
        <Box className={styles.locationFields}>
          {renderFieldInput('countryFrom', 'Country From')}
          {renderFieldInput('countryTo', 'Country To')}
        </Box>
      )}

      {isFieldVisible('vehicleType') && (
        <CustomInput
          inputName="vehicleType"
          inputLabel="Vehicle Type"
          value={values.vehicleType || ''}
          onChange={handleChange}
          error={getError('vehicleType')}
          placeholder="e.g., Bus, Train, Car, Taxi"
        />
      )}
    </Box>
  );
};

export default MandatoryFields;
